var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasStatus)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(("This Ad is " + _vm.statusText)),expression:"`This Ad is ${statusText}`"}],class:['c-active-status', { active: _vm.active }]}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }